import { makeAutoObservable } from "mobx";
import toast from "react-hot-toast";
import { PatientModel } from "src/models/patient";
import { PatientService } from "src/models/patient-service";
import { deletePatientById, getPatientHistory, getPatientList, getPatientWaiting, updatePatientData } from "src/services/patient/patientService";


export class PatientStore {
  
    patients : PatientModel[] = [];

    userId: number = 0;

    patientWaitng: PatientService[] = [];

    patientHistory: PatientService[] = [];

    loading : boolean  = false;

    selectedPatient: PatientModel| undefined = undefined;
  
    constructor() {
      makeAutoObservable(this);
    }

    async setUserId(id: number){
        this.userId = id;
    }


    async getPatients(){
        let result = await getPatientList(this.userId.toString());
        if(result.ok){
            this.patients = result.data;
            if(!this.selectedPatient && result.data.length > 0){
                this.selectedPatient = result.data[0];
            }
        }
        else{
            toast.error(result.message);
        }}

    updateSelectedPatient(patientId: number){
        this.selectedPatient = this.patients.find(x => x.id === patientId);
    }

    async getPatientData(){
        this.loading = true;
        //let user = this.getPrimaryPatientId();
        try{
            
            let res = await getPatientHistory(this.userId ??0);
            if(res.ok){
                this.patientHistory = res.data;
            }else{
                toast.error(res.message);
            }
            res = await getPatientWaiting(this.userId ??0);
            if(res.ok){
                this.patientWaitng = res.data;
            }else{
                toast.error(res.message);
            }
        }
        finally{
            this.loading = false;
        }
    }

    async deletePatient(patientId: number){
            this.loading = true;
            try{
               let result = await deletePatientById(patientId);
               if(result.ok){
                       await this.getPatients();   
               }else{
                toast.error(result.message);
               }
            }finally{
                this.loading = false;
            } 
    }

    getPrimaryPatientId(){
        let patient = this.patients.find(x => x.parentId === null);
        if(patient){
            return patient.id
        }
    }

    getPrimaryPatientMedicareNUmber(){
        let patient = this.patients.find(x => x.parentId === null);
        if(patient){
            return patient.medicareNumber
        }
    }

    async updatePatient(patient: PatientModel){
            this.loading = true;
            try{
               let result = await updatePatientData(patient);
               if(result.ok){
                       await this.getPatients();   
               }else{
                toast.error(result.message);
               }
                return result;
            }finally{
                this.loading = false;
            }
             
    }

}